import React from 'react';
import { Button, Text, VStack } from '@adc/parallax-component-library';
import { Footer, Main, Spinner, TitleActionBar } from 'Components/utility';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
const ForgotPassSecondStep = ({ values, handleSubmitForgotPass, showForgotPasswordConfirmatioMessage, loading, back, }) => {
    const handleResendEmail = () => {
        handleSubmitForgotPass(values.email)
            .then(showForgotPasswordConfirmatioMessage)
            .catch((err) => {
            log.error(err);
        });
    };
    const handleClickDone = () => {
        mediator.publish('router:navigate', '/login');
    };
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { onBack: back, testID: "ForgotPassword", title: i18n.t('CheckYourEmail.title') }),
        loading && React.createElement(Spinner, null),
        React.createElement(VStack, { flex: 1 },
            React.createElement(Text, { testID: "ForgotPassword.title", textAlign: "auto", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", padding: "$4" }, i18n.t('CheckYourEmail.subtitle')),
            React.createElement(Text, { paddingHorizontal: "$4", testID: "ForgotPassword.user-email", color: "$text.100", fontSize: "$bodyBase.strong", fontWeight: "$bodyBase.strong" }, values.email),
            React.createElement(VStack, { justifyContent: "center", alignItems: "center", marginTop: "$4" },
                React.createElement("img", { src: i18n.t('CheckYourEmail.content.checkYourEmail.media.checkYourEmail'), alt: "", style: {
                        objectFit: 'contain',
                        height: '70%',
                    }, id: "ForgotPassword.check-email-img" }),
                React.createElement(Text, { testID: "ForgotPassword.notReceiveEmail", color: "$text.100", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", marginTop: "$4" }, i18n.t('CheckYourEmail.content.checkYourEmail.primaryText')),
                React.createElement(Button, { variant: "tertiary", testID: "ForgotPassword.resendEmail-btn", onPress: handleResendEmail, label: i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label'), "aria-label": i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label') }))),
        React.createElement(Footer, { buttonText: i18n.t('CheckYourEmail.content.checkYourEmail.links.done.label'), onButtonSubmit: handleClickDone, testIDButton: "ForgotPassword.done-btn" })));
};
export default ForgotPassSecondStep;
